import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Kicker({ children, className = "" }) {
  return (
    <p className={`font-cinzel text-xs md:text-sm tracking-[0.35em] uppercase text-hell-gold ${className}`}>
      {children}
    </p>
  );
}
